export default "__VITE_ASSET__CcN0uJ83__"